export const RecruitmentCvTech = {
  path: '/recruitment_cv_techs',
  name: 'recruitment_cv_techs',
  component: () => import('@/views/Recruitment/CvTech/CvTechPage.vue'),
  children: [
    {
      path: '/recruitment_cv_techs/view/:id',
      name: 'recruitment_cv_techs.view',
      component: () => import('@/views/Recruitment/CvTech/Form/CvTechForm.vue'),
    },
  ],
}